import { render } from "./GuardianImport.vue?vue&type=template&id=fd25defe&scoped=true&ts=true"
import script from "./GuardianImport.vue?vue&type=script&lang=ts"
export * from "./GuardianImport.vue?vue&type=script&lang=ts"

import "./GuardianImport.vue?vue&type=style&index=0&id=fd25defe&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd25defe"]])

export default __exports__